import React, { forwardRef, useCallback, useMemo, useState } from "react";
import { POINTER } from "@lookiero/aurora";
import { Text } from "../../atoms/text/Text";
import { TextInput } from "../textInput/TextInput";
import { style as numberInputStyle } from "./NumberInput.style";
const NumberInput = forwardRef(({ value, unit, error, testID = "number-input", onBlur, onFocus, ...props }, ref) => {
    const style = useMemo(() => numberInputStyle(), []);
    const [focused, setFocused] = useState(false);
    const handleOnFocus = useCallback(() => {
        setFocused(true);
        onFocus?.();
    }, [onFocus]);
    const handleOnBlur = useCallback(() => {
        setFocused(false);
        onBlur?.();
    }, [onBlur]);
    return (React.createElement(TextInput, { ...props, ref: ref, keyboardType: "numeric", testID: testID, value: value, onBlur: handleOnBlur, onFocus: handleOnFocus }, unit && (React.createElement(Text, { level: 1, 
        // @ts-ignore
        pointerEvents: POINTER.NONE, style: [style.unit, focused && style.unitFocused, error && style.error], variant: "detail" }, unit))));
});
NumberInput.displayName = "NumberInput";
export { NumberInput };
